<template>
    <div class="search">
        <!--下拉框区域-->
        <div class="dropdown">
            <div class="xiala">
                <span>{{searchActive}}</span>
                <img src="../assets/search/dow.png" alt=""/>
                <dl class="dropdown_menu">
                    <b class="top"><i class="top-arrow1"></i><i class="top-arrow2"></i></b>
                    <dd @click="selectMenu($event)" data-num='1'>摄影图片</dd>
                    <dd @click="selectMenu($event)" data-num='2'>矢量图片</dd>
                    <!--<dd @click="selectMenu($event)" data-num=''>优质视频</dd>-->
                </dl>
            </div>

        </div>
        <!--搜索框-->
        <div class="inpt">
            <!--<img src="../assets/search/xj.png" alt=""/>-->
            <input type="text" v-model="keyword" placeholder="  搜索照片、矢量图和视频，多个词注意用空格分隔"  @keyup.enter="goSearch"/>
            <img v-if="searchActive !== '优质视频'" src="../assets/search/photo_camera.png" alt="" class="camera-btn" @click="showUplaodBox" />
        </div>
        <!--搜索图标-->
        <div class="icon-scrch">
            <img src="../assets/search/serch.png" alt="" @click="goSearch"/>
        </div>

        <div v-if="uploadBoxShowed" v-loading="reverseSearching" element-loading-text="图片分析中..." element-loading-spinner="el-icon-loading" class="upload-box">
            <el-upload
                ref="reverseSearch"
                drag
                action=""
                :auto-upload="false"
                :on-change="handlePreview"
                :http-request="reverseSearch"
                :show-file-list="false"
            >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">拖动图片到这里 或者 <em>点击进行上传</em></div>
            </el-upload>
            <div v-if="previewImg" class="search-btn">
                <div class="search-txt">
                    <img :src="previewImg" height="80">
                    <span>{{ previewImgTitle }}</span>
                </div>
                <div>
                    <el-button @click="doReverseSearch">开始搜索</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {getCookie} from "../util/common";

    export default {
        name: 'search',
        props: {
            typeId: {
                type: Number,
                default: 1
            }
        },
        data() {
            return {
                keyword:'',
                searchActive:'摄影图片',
                dataNum:1,
                uploadBoxShowed: false,
                reverseSearching: false,
                previewImg: '',
                previewImgTitle: '',
                user_name:'',
                user_id:'',
                register_time:'',
                name:'',
                email:'',
                contact_person:'',
            }
        },
        created() {
            this.$get('/me')
                .then( res => {
                    if(res.code == 200){
                        this.user_name = res.data.user.user_name
                        this.user_id = res.data.user.id
                        this.register_time = res.data.user.created_at
                        this.name = res.data.user.name
                        this.email = res.data.user.email
                        this.contact_person = res.data.user.contact_person
                    }
                }).catch(error => {
                console.log(error)
            })
        },
        mounted() {
            if(this.typeId == 2){
                this.searchActive = "矢量图片"
                this.dataNum = 2
            }else if(this.typeId == 1){
                this.dataNum = 1
            }else{
                this.searchActive = "优质视频"
                this.dataNum = ''
            }
        },
        methods: {
            selectMenu(e){
                this.searchActive = e.target.innerText
                this.dataNum = e.target.getAttribute('data-num')
            },
            goSearch(){
                let token = getCookie('token')
                if(!token) {
                    this.$router.push('/login')
                    return;
                }
                if(this.keyword && this.user_id){
                    let data2 = {
                        keywords:this.keyword,
                        user_name:this.user_name,
                        user_id:this.user_id,
                        register_time:this.register_time,
                        name:this.name,
                        email:this.email,
                        contact_person:this.contact_person,
                    }
                    this.$post('/es/keywords',data2)
                        .then( res => {
                        }).catch(errors => {
                        console.log(errors);
                    })
                }
                this.type = this.$route.query.mediaType
                if(this.keyword){
                    let data = {
                        keywords:this.keyword,
                        user_id:this.user_id,
                        type:this.type,
                        page_type:1,
                        current_page:1
                    }
                    this.$post('/es/touchDetail',data)
                        .then( res => {
                        }).catch(errors => {
                        console.log(errors);
                    })
                }

                if(this.dataNum){
                    this.$router.push({name:'Search',query:{keyword:this.keyword,mediaType:this.dataNum}})
                }else{
                    this.$router.push({name:'VideoList',query:{keyword:this.keyword}})
                }
            },
            showUplaodBox() {
                this.uploadBoxShowed = !this.uploadBoxShowed
            },
            handlePreview(file, fileList) {
                console.log(file, fileList)
                const isJPG = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png';
                const isLt5M = file.size / 1024 / 1024 < 5;

                if (!isJPG) {
                    this.$message.error('图片必须是JPG或PNG格式!');
                    return;
                }
                if (!isLt5M) {
                    this.$message.error('图片必须小于5MB!');
                    return;
                }
                const _URL = window.URL || window.webkitURL
                this.previewImg = _URL.createObjectURL(file.raw)
                this.previewImgTitle = file.name
            },
            reverseSearch(file) {
                this.reverseSearching = true
                const formData = new FormData()
                formData.append('image', file.file)
                this.$postByFormData('/image/reverse_search', formData).then(res => {
                    this.reverseSearching = false
                    if (res.data.result) {
                        this.$router.push({name:'ReverseSearch',query:{fid:res.data.result,mediaType:this.dataNum}})
                    } else {
                        this.$message({
                            message: '请换张图片',
                            type: 'error'
                        });
                    }
                })
            },
            doReverseSearch() {
                let token = getCookie('token')
                if(!token) {
                    this.$router.push('/login')
                    return;
                }
                this.$refs['reverseSearch'].submit();
            }
        }
    }
</script>


<style scoped>
    * {  padding: 0; margin: 0; box-sizing: border-box; }
    .search{background: #fff;height: 60px;display: flex;justify-content: space-between;position: absolute;bottom: 60px;z-index: 11;left: 50%;margin-left: -360px;}
    .dropdown{width: 110px;text-align: center;line-height: 60px;cursor: pointer;}
    .dropdown {position: relative;}
    .dropdown_menu {display: none;background: #fff;position: absolute;top: 60px;right: 0px;z-index: 1000;width: 110px;padding:10px 0;text-align: center;border-top: 1px solid #ddd;}
    .dropdown_menu dd{line-height: 34px!important;}
    .dropdown_menu dd:hover{background: #e0e0e0;}
    .dropdown_menu dd a{color: #333;line-height: 34px;font-size:14px;}
    .xiala{font-size: 14px;}
    .xiala:hover > .dropdown_menu{display: block}
    .xiala img{margin-top: 24px;}
    .inpt{width: 510px;position: relative; padding-left: 0; padding-right: 0;}
    .inpt input {padding-left: 10px;}
    /* .inpt img{margin-top: 18px;position: absolute;} */
    input {border: none;height: 60px;line-height: 60px;width: 100%;/*padding-left: 40px;*/outline: none;font-size: 16px;}
    .icon-scrch {width: 110px;background: #FF9F00;text-align: center;}
    .icon-scrch img {margin-top: 16px;cursor: pointer;}
    .top-arrow1,.top-arrow2 {width:0;height:0;display:block;position:absolute;left:30px;top:-17px;z-index:5; /*����ie8-*/ border-top:8px transparent dashed;border-left:6px transparent dashed;border-right:6px transparent dashed;border-bottom:8px white solid;overflow:hidden;}
    .top-arrow1 {border-bottom:9px #ddd solid;}
    .top-arrow2 {top:-15px;border-bottom:9px #fff solid;}
    .camera-btn {
        position: absolute;
        top: 2px;
        right: 8px;
        cursor: pointer;
        width: 36px;
        height: 36px;
    }
    .upload-box {
        position: absolute;
        top: 60px;
        width: 730px;
        background: white;
    }
    .upload-box .search-btn {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .upload-box .search-btn .search-txt {
        display: flex;
        align-items: center;
    }
    .upload-box .search-btn .search-txt span {
        margin: 0 8px;
        word-break: break-all;
    }
    .upload-box .search-btn .el-button {
        background: #FF9F00;
        color: white;
        border: 0;
        padding: 12px 20px;
    }

</style>
<style>
.search .el-upload-dragger {
    width: 730px !important;
    border-radius: 0 !important;
}
.search .el-upload:focus .el-upload-dragger{border-color:#2e2e2e}
.search .el-upload-dragger:hover {
    border: 1px dashed #2e2e2e;
}
.search .el-upload-dragger .el-upload__text em {
    color: #2e2e2e;
    font-weight: bold;
    font-size: 16px;
}
.upload-box .el-loading-spinner i {
    color: #FF9F00;
}
.upload-box .el-loading-spinner .el-loading-text {
    color: #FF9F00;
}
</style>
